import http from './http'

class Mailer {
  resendWelcomeEmail (id) {
    return http.get(`/assignors/welcome/${id}`)
  }

  payerSendWelcomeEmail (id) {
    return http.post(`payer_send_welcome/${id}`)
  }

  templates () {
    return http.get('/mail_templates/list')
  }
}

export default new Mailer()



// WEBPACK FOOTER //
// ./src/services/mailer.js